import { MATCH_FORMAT, normalizeMatchFormat } from '../constants/matchFormats'

const MATCH_FORMAT_RULES = {
  [MATCH_FORMAT.TRADITIONAL]: {
    maxGamesPerSet: 7,
    minimumSetsForNonRetiredMatch: 2,
    maximumSets: 3,
    setsNeededToWin: 2,
  },
  [MATCH_FORMAT.PRO_SET_8]: {
    maxGamesPerSet: 9,
    minimumSetsForNonRetiredMatch: 1,
    maximumSets: 1,
    setsNeededToWin: 1,
  },
}

export function getMatchFormatRules(matchFormat) {
  return MATCH_FORMAT_RULES[normalizeMatchFormat(matchFormat)]
}
